import { Dialog, DialogContent } from '@material-ui/core';
import React from 'react';
import { useStyles } from './styles';
import DaumPostcode, { AddressData } from 'react-daum-postcode';
import { UpdateQuotationUserInput } from '@generated/graphql';
interface prop {
  open: boolean;
  onClose: () => void;
  setAddress?: React.Dispatch<
    React.SetStateAction<{ full: string; short: string }>
  >;
  onSubmit?: (updateData: UpdateQuotationUserInput) => void;
}

const PostCodeDialog = ({ open, setAddress, onClose, onSubmit }: prop) => {
  const { contentWrapper, dialog } = useStyles();
  const onComplete = (data: AddressData) => {
    const { roadAddress, buildingName, sido, sigungu } = data;
    const selectedAddress: { full: string; short: string } = {
      full: roadAddress + (buildingName ? ', ' + buildingName : ''),
      short: `${sido} ${sigungu}`
    };

    if (setAddress) {
      setAddress(selectedAddress);
    }

    if (onSubmit) {
      onSubmit({
        fullAddress: selectedAddress.full,
        shortAddress: selectedAddress.short
      });
    }
    onClose();
  };

  return (
    <Dialog className={dialog} open={open} onClose={onClose} maxWidth={'sm'}>
      <DialogContent className={contentWrapper}>
        <DaumPostcode onComplete={onComplete} height={'100%'} />
      </DialogContent>
    </Dialog>
  );
};

export default PostCodeDialog;
